module.exports = __webpack_public_path__ + "static/media/orders.ac14ad26.svg";